import TextField from "@material-ui/core/TextField";
import { Email, AccessTime, Add, Delete } from "@material-ui/icons";
import React, { useState } from "react";
import styled, { keyframes } from "styled-components";

const HOURS   = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0"));
const MINUTES = Array.from({ length: 12 }, (_, i) => String(i * 5).padStart(2, "0"));

function TabNotificacaoIFS({ values, touched, errors, handleChange, setFieldValue }) {
  const [hour,   setHour]   = useState("08");
  const [minute, setMinute] = useState("00");

  const horarios = values.emailNotificacaoHorarios || [];

  const addHorario = () => {
    const time = `${hour}:${minute}`;
    if (horarios.includes(time)) return;
    setFieldValue("emailNotificacaoHorarios", [...horarios, time].sort());
  };

  const removeHorario = (time) => {
    setFieldValue("emailNotificacaoHorarios", horarios.filter((h) => h !== time));
  };

  return (
    <ModernFormContainer>
      {values.id && (
        <SectionCard>
          <SectionHeader>
            <SectionIcon>
              <Email />
            </SectionIcon>
            <SectionTitle>Notificações</SectionTitle>
          </SectionHeader>

          <FormGrid columns={1}>
            <StyledFieldContainer>
              <FieldLabel>
                <Email style={{ fontSize: '18px', marginRight: '8px', color: '#27ae60' }} />
                E-mail de Notificação
              </FieldLabel>
              <TextField
                fullWidth
                InputLabelProps={{ shrink: true }}
                id="emailNotificacao"
                name="emailNotificacao"
                placeholder="email@empresa.com.br"
                value={values.emailNotificacao}
                onChange={handleChange}
                error={touched.emailNotificacao && Boolean(errors.emailNotificacao)}
                helperText={
                  (touched.emailNotificacao && errors.emailNotificacao) ||
                  "E-mail utilizado pelo backend para envio de notificações de erro"
                }
                autoComplete="off"
                variant="outlined"
                type="email"
              />
            </StyledFieldContainer>
          </FormGrid>

          <Divider />

          <SubHeader>
            <AccessTime style={{ fontSize: '18px', marginRight: '8px', color: '#27ae60' }} />
            Horários de Envio
            <SlotCount>{horarios.length} horário{horarios.length !== 1 ? "s" : ""}</SlotCount>
          </SubHeader>
          <SubDesc>
            Defina os horários em que o e-mail de notificação será disparado pelo backend.
          </SubDesc>

          {horarios.length > 0 ? (
            <SlotList>
              {horarios.map((time) => (
                <SlotChip key={time}>
                  <AccessTime style={{ fontSize: '13px', marginRight: '5px', color: '#27ae60' }} />
                  {time}
                  <RemoveBtn type="button" onClick={() => removeHorario(time)} title="Remover">
                    <Delete style={{ fontSize: '13px' }} />
                  </RemoveBtn>
                </SlotChip>
              ))}
            </SlotList>
          ) : (
            <EmptySlots>Nenhum horário configurado</EmptySlots>
          )}

          <AddRow>
            <TimeSelect value={hour} onChange={(e) => setHour(e.target.value)}>
              {HOURS.map((h) => <option key={h} value={h}>{h}</option>)}
            </TimeSelect>
            <TimeSep>:</TimeSep>
            <TimeSelect value={minute} onChange={(e) => setMinute(e.target.value)}>
              {MINUTES.map((m) => <option key={m} value={m}>{m}</option>)}
            </TimeSelect>
            <AddButton type="button" onClick={addHorario}>
              <Add style={{ fontSize: '17px', marginRight: '5px' }} />
              Adicionar
            </AddButton>
          </AddRow>
        </SectionCard>
      )}
    </ModernFormContainer>
  );
}

export default TabNotificacaoIFS;

// ── Styled Components ──────────────────────────────────────────────────────

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const ModernFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-family: 'Mulish', sans-serif;
`;

const SectionCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e8e8e8;
  animation: ${fadeIn} 0.5s ease;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #d0d0d0;
  }
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f0f0;
`;

const SectionIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(39, 174, 96, 0.08);
  color: #27ae60;
  margin-right: 12px;
  svg { font-size: 22px; }
`;

const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  font-family: 'Mulish', sans-serif;
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid #f0f0f0;
  margin: 20px 0 16px;
`;

const SubHeader = styled.div`
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 6px;
  font-family: 'Mulish', sans-serif;
  gap: 4px;
`;

const SubDesc = styled.p`
  font-size: 13px;
  color: #64748b;
  margin: 0 0 14px 0;
  font-family: 'Mulish', sans-serif;
`;

const SlotCount = styled.span`
  margin-left: auto;
  font-size: 12px;
  font-weight: 700;
  color: #27ae60;
  background: rgba(39, 174, 96, 0.1);
  padding: 3px 10px;
  border-radius: 20px;
`;

const SlotList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 14px;
`;

const SlotChip = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 10px 6px 12px;
  background: rgba(39, 174, 96, 0.06);
  border: 1px solid rgba(39, 174, 96, 0.25);
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  color: #2c3e50;
  font-family: 'Mulish', sans-serif;
`;

const RemoveBtn = styled.button`
  background: none;
  border: none;
  padding: 0 0 0 6px;
  cursor: pointer;
  color: #e74c3c;
  display: flex;
  align-items: center;
  opacity: 0.6;
  transition: opacity 0.2s;
  &:hover { opacity: 1; }
`;

const EmptySlots = styled.p`
  font-size: 13px;
  color: #94a3b8;
  margin: 0 0 14px 0;
  font-style: italic;
  font-family: 'Mulish', sans-serif;
`;

const AddRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 10px;
`;

const TimeSelect = styled.select`
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  font-family: 'Mulish', sans-serif;
  font-weight: 600;
  color: #2c3e50;
  background: white;
  cursor: pointer;
  outline: none;
  min-width: 70px;

  &:focus {
    border-color: #27ae60;
    box-shadow: 0 0 0 3px rgba(39, 174, 96, 0.1);
  }
`;

const TimeSep = styled.span`
  font-size: 20px;
  font-weight: 700;
  color: #64748b;
`;

const AddButton = styled.button`
  display: flex;
  align-items: center;
  padding: 8px 16px;
  background: linear-gradient(135deg, #27ae60 0%, #219a52 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  font-family: 'Mulish', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(39, 174, 96, 0.3);

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(39, 174, 96, 0.4);
  }
  &:active { transform: translateY(0); }
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
`;

const StyledFieldContainer = styled.div`
  display: flex;
  flex-direction: column;

  .MuiOutlinedInput-root {
    border-radius: 10px;
    transition: all 0.3s ease;
    &:hover { box-shadow: 0 2px 8px rgba(39, 174, 96, 0.1); }
    &.Mui-focused { box-shadow: 0 4px 12px rgba(39, 174, 96, 0.2); }
  }
  .MuiInputLabel-outlined, .MuiOutlinedInput-input { font-family: 'Mulish', sans-serif; }
`;

const FieldLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  font-family: 'Mulish', sans-serif;
`;
